import { useMemo } from 'react';

import { useUsers } from '@adsk/alloy-provider';

import { transformHQUsersToPgUsersResponse } from '../helpers/transformers/transformHqUserToPgUser';

export default () => {
  const { data: users, loading, error } = useUsers();

  const data = useMemo(
    () => (users ? transformHQUsersToPgUsersResponse(users) : undefined),
    [users],
  );

  return {
    data,
    isError: error,
    isLoading: loading,
  };
};
